import { lazy, Suspense, useEffect } from 'react'
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import { CartDrawer } from './components/CartDrawer'
import { Header } from './components/Header'
import { CartProvider } from './lib/cart'
import { AccountPage } from './pages/AccountPage'
import { AdminPage } from './pages/AdminPage'
import { CheckoutResultPage } from './pages/CheckoutResultPage'
import { HomePage } from './pages/HomePage'
import { ProductPage } from './pages/ProductPage'

const AmbientCanvas = lazy(() =>
  import('./components/AmbientCanvas').then((module) => ({ default: module.AmbientCanvas })),
)

function ScrollManager() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      window.requestAnimationFrame(() => document.querySelector(location.hash)?.scrollIntoView({ behavior: 'smooth' }))
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' })
    }
  }, [location.hash, location.pathname])

  return null
}

function NotFound() {
  return (
    <div className="page-shell">
      <Header />
      <main className="result-page section-frame"><section className="result-card"><span className="eyebrow">ERROR // 404</span><h1>Out of orbit.</h1><p>The page you are looking for does not exist or has changed coordinates.</p><Link className="button button--primary" to="/">Back to CheatsEclipse</Link></section></main>
    </div>
  )
}

export default function App() {
  return (
    <CartProvider>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Suspense fallback={null}>
        <AmbientCanvas />
      </Suspense>
      <div id="main-content" className="app-layer">
        <ScrollManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/p/:slug" element={<ProductPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/checkout/success" element={<CheckoutResultPage outcome="success" />} />
          <Route path="/checkout/cancelled" element={<CheckoutResultPage outcome="cancelled" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CartDrawer />
      </div>
    </CartProvider>
  )
}
